
import _ from 'lodash'
class Order {
}

class OrderItem {
  price
  discount
  specialDiscount
  options
  excludedDiscount
  quantity

  constructor (data) {
    Object.assign(this, data)
    this.price = this.price || 0
    this.discount = this.discount || 0
    this.specialDiscount = this.specialDiscount || 0
    this.quantity = this.quantity || 1

    this.options = this.options || []
    _.each(this.options, opt => {
      _.each(opt, o => {
        o.price = o.price || 0
        o.quantity = +o.quantity || 1
      })
    })
    this.excludedDiscount = this.excludedDiscount || false
  }

  getPrice () {
    let total = (this.price - this.discount - this.specialDiscount) * this.quantity
    _.each(this.options, opt => {
      _.each(opt, o => {
        total += o.price * o.quantity
      })
    })
    return total
  }
}

class OrderDiscount {
  percent
  amount
  overrideItem

  constructor (data) {
    Object.assign(this, data)
    this.percent = this.percent || 0
    this.amount = this.amount || 0
    this.overrideItem = this.overrideItem || false
  }

  isEmpty () {
    return this.percent === 0 && this.amount === 0
  }
}

export {
  Order,
  OrderItem,
  OrderDiscount,
}



// WEBPACK FOOTER //
// ./src/models/order.js